import {
  zlbApiPayImportResultPost,
  // 二次确认导入
  zlbApiPayImportSavePost,
  // 导入任务提交
  zlbApiPayImportSubmitPost,
} from '@/api/zlbPay';
import { responseErrorHandle } from '@/utils/utils';
import {
  addOfficialCard,
  asyncOfficailCard,
  bindOfficialCard,
  deleteOfficialCard,
  exportOfficialCardList,
  fetchOfficialList,
  getOfficialCardExportResult,
  getTemplate,
  reqDetail,
  searchOperator,
  unbindOfficialCard,
} from '../services/index';

export default {
  namespace: 'officalCardManage',
  state: {},
  effects: {
    /**
     * 同步公务卡
     */
    *asyncOfficailCard({ payload }, { call }) {
      const result = yield call(asyncOfficailCard, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 列表展示，条件筛选接口
     */
    *fetchOfficialList({ payload }, { call }) {
      const result = yield call(fetchOfficialList, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 新增公务卡
     */
    *addOfficialCard({ payload }, { call }) {
      const result = yield call(addOfficialCard, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 公务卡绑定
     */
    *bindOfficialCard({ payload }, { call }) {
      const result = yield call(bindOfficialCard, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 公务卡解绑
     */
    *unbindOfficialCard({ payload }, { call }) {
      const result = yield call(unbindOfficialCard, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 公务卡删除
     */
    *deleteOfficialCard({ payload }, { call }) {
      const result = yield call(deleteOfficialCard, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 查看单个银行账号明文信息
     */
    *reqDetail({ payload }, { call }) {
      const result = yield call(reqDetail, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 根据持卡人姓名精确查询单位内人员列表
     */
    *searchOperator({ payload }, { call }) {
      const result = yield call(searchOperator, payload);
      responseErrorHandle(result);
      return result;
    },
    *getOfficialCardTemplate({ payload }, { call }) {
      const result = yield call(getTemplate, payload);
      return result;
    },
    *submitTask({ payload }, { call }) {
      const result = yield call(zlbApiPayImportSubmitPost, payload);
      return result;
    },
    *queryImportResult({ payload }, { call }) {
      const result = yield call(zlbApiPayImportResultPost, payload);
      return result;
    },
    *confirmImport({ payload }, { call }) {
      const result = yield call(zlbApiPayImportSavePost, payload);
      return result;
    },
    *exportOfficialCardList({ payload }, { call }) {
      const result = yield call(exportOfficialCardList, payload);
      return result;
    },
    *getOfficialCardExportResult({ payload }, { call }) {
      const result = yield call(getOfficialCardExportResult, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
